import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBaseEntityData } from '@core/interfaces/entity-request.interface';
import { EntityApiService } from '@core/services/entity-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Catalog, FilterStatus, IAuctionFilterDto } from '@shared/interfaces/search.interface';
import { SortAuctionsPipe } from '@shared/pipes/sort-auctions.pipe';
import { LanguageService } from '@shared/services/language.service';
import { MetaManagerService } from '@shared/services/meta-manager.service';
import { SearchService } from '@shared/services/search.service';
import { AuctionView } from 'src/app/articles-manager/interfaces/auction.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss']
})
@UntilDestroy()
export class SellerComponent implements OnInit {

  public entityData: IBaseEntityData;
  public auctionsMemorabidList: AuctionView[] = [];
  public auctionsMarketplaceList: AuctionView[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _languageService: LanguageService,
    private _entityCoreApiService: EntityApiService,
    private _searchService: SearchService,
    private _metaService: MetaManagerService,
    private _sortAuctionsPipe: SortAuctionsPipe
  ) { }

  ngOnInit(): void {
    this._route.params.pipe(untilDestroyed(this)).subscribe(
      params => {
        if (!!params['id']) {
          this.getEntityByPk(+params['id']);
          this.getAuctionList(+params['id']);
        }
      }
    );
  }

  onAuctionStatusFilterChanged(data: { auctionStatusFilter: FilterStatus }) {
    this.getAuctionList(this.entityData.idEntity, data.auctionStatusFilter);
  }

  private getEntityByPk(idEntity: number): void {
    this._entityCoreApiService.getBaseDataByPk(idEntity).subscribe(
      entity => {
        this.entityData = entity;
        this._metaService.updateTitleAndMeta(
          this.entityData.entityName,
          "",
          environment.APPOrigin + '/seller/' + this.entityData.idEntity,
          this.entityData.photoFullPath
        );
      }
    );
  }

  private getAuctionList(idEntity: number, auctionStatus: FilterStatus = FilterStatus.All): void {
    let filters: IAuctionFilterDto = {
      idLanguage: this._languageService.userSelectedLanguage.idLanguage,
      searchText: '',
      idAuctionType: 2,
      idDetail: null,
      onlySigned: false,
      idSport: null,
      idCompetition: null,
      idTeam: null,
      onlyNew: false,
      onlyExpiring: false,
      onlyArriving: false,
      onlyBuyNow: false,
      auctionStatus: auctionStatus,
      idEntity: idEntity,
      idCampaign: null,
      idPromoter: null,
      idActiveAuction: null,
      idTagList: [],
      idCategoriesList: [],
      catalog: Catalog.All,
      orderBy: 'evidence',
      orderDirection: 'desc',
    };

    this._searchService.setFilters(this._searchService.searchRoute, {
      ...filters,
    });

    this._searchService.getAllV2(filters).subscribe((auctionList) => {
      this.auctionsMemorabidList = auctionList.filter(
        (a) => a.auctionTypeDescription.toLowerCase() == 'memorabid'
      );
      this._sortAuctionsPipe.transform(this.auctionsMemorabidList);
      this.auctionsMarketplaceList = auctionList.filter(
        (a) => a.auctionTypeDescription.toLowerCase() != 'memorabid'
      );
      this._sortAuctionsPipe.transform(this.auctionsMarketplaceList);
    });
  }

}
